import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=4fe536e7&scoped=true"
import script from "./PostAdd.vue?vue&type=script&lang=js"
export * from "./PostAdd.vue?vue&type=script&lang=js"
import style0 from "./PostAdd.vue?vue&type=style&index=0&id=4fe536e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe536e7",
  null
  
)

export default component.exports